/**
 * DevExtreme (ui/tree_list/ui.tree_list.sorting.js)
 * Version: 18.2.4
 * Build date: Mon Dec 17 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var treeListCore = require("./ui.tree_list.core"),
    sortingModule = require("../grid_core/ui.grid_core.sorting");
treeListCore.registerModule("sorting", sortingModule);



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/devextreme/ui/tree_list/ui.tree_list.sorting.js
// module id = ../../../../devextreme/ui/tree_list/ui.tree_list.sorting.js
// module chunks = common